/**
 * Which branch a REN on a sale is from — as ERP shows it, so a co-share with
 * another branch can't be missed. `agent` is a `sale.parties.agents` row:
 * `branch` (name) and `other_branch` (not the reader's branch) come from the server.
 * Renders nothing when the branch is unknown.
 */
export function OtherBranchTag() {
  return (
    <span style={{ fontSize: 10, fontWeight: 700, padding: '1.5px 7px', borderRadius: 999, background: 'color-mix(in srgb,var(--warn) 14%,var(--surface))', color: 'var(--warn)', letterSpacing: '.04em', whiteSpace: 'nowrap' }}>
      OTHER BRANCH
    </span>
  );
}

export default function AgentBranch({ agent, style }) {
  if (!agent?.branch) return null;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', fontSize: 11.5, color: 'var(--muted)', marginTop: 2, ...style }}>
      <span>{agent.branch} branch</span>
      {agent.other_branch && <OtherBranchTag />}
    </div>
  );
}
